import i18next, { InitOptions, TOptionsBase } from 'i18next';
import DOMPurify from 'dompurify';
// options from i18next.t, exported to type to make it shorter
export type TTranslateOptions = TOptionsBase &
  InitOptions & {
    returnDetails?: true;
    returnObjects?: true;
  } & {
    [key: string]: string | number;
  };

export function translate(value: string, options?: TTranslateOptions): string {
  if (options) {
    return DOMPurify.sanitize(i18next.t(value, options)?.toString());
  } else {
    return DOMPurify.sanitize(i18next.t(value)?.toString());
  }
}
